export default __webpack_public_path__ + "static/media/af8b48690f8b08dd12974f37a5361cb71581613683801.4d016ad3.webp";